// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nform[data-v-ee5c0d7e] {\n    position: relative;\n}\n.close-btn[data-v-ee5c0d7e] {\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 2;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
